import React from 'react';
import PropTypes from 'prop-types';

import { makeSequence } from 'dpl/shared/utils';
import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';

export default function HomepageFooterSectionLinksSkeleton({
  sectionTitle,
  linkCount
}) {
  return (
    <section className="HomepageFooterSectionLinksSkeleton">
      <div className="container-xl">
        <h5 className="font-20 md:font-24 mb6 mb8-md lh-title">
          {sectionTitle}
        </h5>
        <ul className="HomepageFooterSectionLinksSkeleton__listItems">
          {makeSequence(linkCount).map(index => (
            <li key={index} className="mb2">
              <SkeletonBlock
                className="secondary font-14 md:font-18"
                height="1em"
                width="80%"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

HomepageFooterSectionLinksSkeleton.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  linkCount: PropTypes.number.isRequired
};
